import React from 'react';
import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z = ".sOxsy{height:100%;overflow:hidden;width:100%}[dir] .sOxsy{border:0}";
var styles = {"iframe":"sOxsy"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Iframe = (_a) => {
  var _b = _a, {
    iframeRef,
    isViewer
  } = _b, otherProps = __objRest(_b, [
    "iframeRef",
    "isViewer"
  ]);
  return /* @__PURE__ */ React.createElement(
    "iframe",
    __spreadValues({
      ref: iframeRef,
      className: styles.iframe,
      title: "remote content",
      style: { backgroundColor: "transparent" },
      allow: isViewer ? "fullscreen; autoplay" : "fullscreen",
      allowFullScreen: true
    }, otherProps)
  );
};

export { Iframe as default };
//# sourceMappingURL=Iframe.js.map
